export default {
    bind(el, binding) {
        el.dataset.highlightclass = binding.value;
    }
};
